import React from "react";

import { format } from "date-fns";

import WebUserStatusButton from "../button/WebUserStatusButton";
import WebUserResetPWButton from "../button/WebUserResetPWButton";
import WebCreateAdminGrantButton from "../button/WebCreateAdminGrantButton";
import WebConfigAdminGrantButton from "../button/WebConfigAdminGrantButton";

const WebConfigMemberInfo = ({ userKind, subDomain_info, member_info, toggleModalOpened, togglePWModalOpened, toggleCreateSubDomainAdminModalOpened, toggleSubDomainAdminModalOpened }) => {
    return (
        // teacher/class 탭과 동일한 list-table 행 스타일 (권한/상태 배지 컴포넌트는 기존 그대로 유지)
        // 주의: display:flex 클래스는 td가 아니라 td 내부 div에 적용 (table-cell 박스 유지 목적)
        <tr>
            <td className="text-center">
                <div className="d-flex align-items-center justify-content-center">
                    <div className="landscape-to-portrait mr-1 area-20 fit-content">
                        {
                            userKind === "hiclasstv" &&
                            <WebCreateAdminGrantButton
                                subDomainSeq={subDomain_info.subDomainSeq}
                                subDomainName={subDomain_info.subDomainName}
                                member_info={member_info}
                                toggleModalOpened={toggleCreateSubDomainAdminModalOpened}
                            />
                        }
                        <WebConfigAdminGrantButton
                            subDomainSeq={subDomain_info.subDomainSeq}
                            subDomainName={subDomain_info.subDomainName}
                            member_info={member_info}
                            toggleModalOpened={toggleSubDomainAdminModalOpened}
                        />
                    </div>
                    {/* 260804 닉네임이 길 때 잘리지 않고 옆 컬럼을 침범하던 문제 수정 - flex 자식이 줄어들지 않던 것을
                        admin-ellipsis-cell(min-width:0)로 고치고 텍스트에 말줄임(...) 처리 추가 */}
                    <div className="d-flex align-items-center admin-ellipsis-cell" style={{ flex: '1 1 auto' }}>
                        <span title={member_info.userNickname} className="hiclass-text admin-ellipsis-text">{member_info.userNickname}</span>
                    </div>
                </div>
            </td>
            <td className="info status text-center">
                <div className="landscape-to-portrait">
                    <WebUserStatusButton
                        subDomainSeq={subDomain_info.subDomainSeq}
                        member_info={member_info}
                        toggleModalOpened={toggleModalOpened}
                    />
                    <WebUserResetPWButton
                        subDomainSeq={subDomain_info.subDomainSeq}
                        member_info={member_info}
                        toggleModalOpened={togglePWModalOpened}
                    />
                </div>
            </td>
            <td className="info status small text-center">
                <div className="landscape-to-portrait">
                    <div className="list-row justify-content-center align-items-center px-1 area-50">
                        <span>{member_info.userLoginDT}</span>
                    </div>
                    <div className="list-row justify-content-center align-items-center px-1 area-50">
                        <span>{member_info.userSignUpDT}</span>
                    </div>
                </div>
            </td>
        </tr>
    );
}

export default WebConfigMemberInfo;